import Button from '@/components/Buttons/Button';
import videoCardVideo from '@/images/avatars/video_card_preview.mp4';
import videoCardImage from '@/images/avatars/video_card_preview.png';
import { CreateAvatarModal } from '@/pages/avatar';
import { Presenter } from '@d-id/types';
import styled from '@emotion/styled';
import { Close } from '@mui/icons-material';
import { IconButton, Typography } from '@mui/material';
import { useState } from 'react';

const CardContainer = styled.div`
    width: 100%;
    min-height: 14rem;
    background-color: ${({ theme }) => theme.colors.black[100]};
    border-radius: 16px;
    padding: 1.2rem;
    display: flex;
    gap: 1.6rem;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
`;

const CloseButton = styled(IconButton)`
    position: absolute;
    top: 8px;
    right: 8px;
`;

const TitleContainer = styled.title`
    display: flex;
    gap: 1rem;
`;

const NewTag = styled(Typography)`
    background: #ddf7e7;
    color: #0d7656;
    border-radius: 6px;
    padding: 0.6rem 0.8rem;
    font-weight: 600;
    font-size: 1rem;
    line-height: 1rem;
    width: fit-content;
`;

const VideoWrapper = styled.div`
    border-radius: 8px;
    height: 100%;
    aspect-ratio: 1 / 1;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 1080px) {
        display: none;
    }
`;

const StyledVideo = styled.video`
    height: 14rem;
`;

const InformationContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    flex-shrink: 0;
`;

const CreateAvatarButton = styled(Button)`
    width: fit-content;
    font-size: 1.4rem;
    line-height: 2rem;
    padding: 0.7rem 0.8rem;
`;

interface IProps {
    onAvatarUpload: (avatar?: Presenter) => void;
    handleModalOpen: () => void;
    show: boolean;
}

function AvatarDiscoverabilityCard({ onAvatarUpload, handleModalOpen, show }: IProps) {
    const [open, setOpen] = useState(true);

    const handleVideoMouseEnter = (e: any) => {
        e.target.play();
    };

    const handleVideoMouseLeave = (e: any) => {
        e.target.load();
        e.target.currentTime = 0;
    };

    if (!(open && show)) {
        return <></>;
    }

    return (
        <>
            <CardContainer>
                <CloseButton
                    disableRipple
                    onClick={() => {
                        setOpen(false);
                    }}>
                    <Close fontSize="medium" />
                </CloseButton>
                <VideoWrapper>
                    <StyledVideo
                        src={videoCardVideo}
                        poster={videoCardImage}
                        onMouseEnter={handleVideoMouseEnter}
                        onMouseLeave={handleVideoMouseLeave}
                        loop
                        muted
                    />
                </VideoWrapper>
                <InformationContainer>
                    <TitleContainer>
                        <Typography variant="h4">Personal Avatar</Typography>
                        <NewTag variant="body2">New</NewTag>
                    </TitleContainer>
                    <Typography variant="body2" lineHeight="2.24rem">
                        Engage your audience with lifelike
                        <br />
                        AI Avatar videos
                    </Typography>
                    <CreateAvatarButton variant="contained" color="primary" onClick={handleModalOpen}>
                        Create Avatar
                    </CreateAvatarButton>
                </InformationContainer>
            </CardContainer>
            <CreateAvatarModal from="editor" onUpload={onAvatarUpload} />
        </>
    );
}

export default AvatarDiscoverabilityCard;
